import * as actionType from './actionTypes'
import { setCSRBusinessFunctionItemsType } from '../../../../actions/globalActionTypes'

export const fetchGrantsActivity = payload => ({
    type: actionType.fetchGrantsActivityType,
    payload,
  });
  export const singleExchanges = payload => ({
    type: actionType.singleExchangesType,
    payload,
  });

export const fetchLazyData = payload => ({
  type: actionType.fetchLazyDataType,
  payload,
})

//recurring grants lazy 
export const fetchRecurringLazyData = payload => ({
  type: actionType.fetchRecurringLazyDataType,
  payload,
})
export const setScroll = payload => ({
  type:'SET_SCROLL_TOP',
  payload,
})


export const resetData = payload => ({
  type: actionType.resetDataType,
  payload,
})

export const cancelTxnSchedule = payload => ({
  type: actionType.cancelTxnScheduleType,
  payload,
})

export const startDateMobile = payload =>({
  type: actionType.startDateMobileType,
  payload
});

export const endDateMobile = payload =>({
  type: actionType.endDateMobileType,
  payload
});

export const fetchGrantData = payload => ({
  type:actionType.getGrantDetailsType,
  payload
});

export const selectGAtab = payload =>({
  type: actionType.selectGAtabType,
  payload
})

export const setFiltered = payload =>({
  type: actionType.setFilteredType,
  payload
})

export const setCSRBusinessData = payload => ({
  type: setCSRBusinessFunctionItemsType,
  payload
})

export const setAllSingleGrants = payload => ({
  type: actionType.setAllSIngleGrantsType,
  payload
})

export const updateSingleGrants = (payload) => ({
  type: actionType.updateSingleGrantsType,
  payload
})

export const showGaLoader = () => ({
  type: actionType.showGaLoaderType
})